import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { Headers, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { ConstantService } from '../../components/common/utils/constant.service';
import { AsesoriaVirtual } from './citas-asesosr-virtual.entity';
import { Cliente, ClienteLogin, ClienteResumen, UsuarioVamTit } from '../login/cliente_login';
import { SegurosContratadosEntity } from '../masivos/datosGenerales/entities/seguros_contratados_entity';
import { PolizaEntity } from '../empresas/entities/polizas_cliente_entity';
import { ClienteIndividualEntity } from '../masivos/datosGenerales/entities/datos_generales_individual_entity';

declare var jQuery: any;

@Injectable()
export class CitasAsesorVirtualService {
    userMasivos: Cliente;
    private url = "utils";
    private urlIndividual = "infoClienteIndividual";
    private urlVam = "vamTittular";

    constructor(private authHttp: AuthHttp, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
        this.urlIndividual = constantService.API_ENDPOINT + this.urlIndividual;
        this.urlVam = constantService.API_ENDPOINT + this.urlVam;
    }

    GetCitas(ced: string): Observable<any> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url + "/GetCitas/" + ced, options).map(this.extractData)
            .catch(this.handleError);
    }

    CancelarCita(objeto: AsesoriaVirtual): Observable<any> {
        let body = JSON.stringify(objeto);
        let headers = new Headers({ 'Content-Type': 'application/form-data', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/CancelarCita", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    consultaSegurosContratados(): Observable<SegurosContratadosEntity> {
        this.userMasivos = jQuery.parseJSON(this.sessionStorageService.retrieve("usermasivos"));
        let body = JSON.stringify(this.userMasivos);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.urlIndividual + "/consultarSeguros", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    ConsultarPolizasVamTitular(usuarioVamTit: UsuarioVamTit): Observable<PolizaEntity[]> {
        let body = JSON.stringify(usuarioVamTit);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.urlVam + "/consultarPolVamTit", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    consultaSegurosContratadosCoorporativos(cliente: ClienteResumen): Observable<SegurosContratadosEntity> {
        let body = JSON.stringify(cliente);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.urlIndividual + "/consultarVehiculosCorporativos", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    datosClienteIndividual(): Observable<ClienteIndividualEntity> {
        this.userMasivos = jQuery.parseJSON(this.sessionStorageService.retrieve("usermasivos"));
        let body = JSON.stringify(this.userMasivos);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.urlIndividual +"/consultarIndividual", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    GetVamTitular(cliente: ClienteLogin): Observable<any>{
        let body = JSON.stringify(cliente);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.urlVam + "/consultarVamTit", body, options).map(this.extractData)
          .catch(this.handleError);
      }

    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/citas/citas-asesor-virtual.service.ts